import { render, staticRenderFns } from "./CourseInProfileList.vue?vue&type=template&id=f0b80520&"
import script from "./CourseInProfileList.vue?vue&type=script&lang=js&"
export * from "./CourseInProfileList.vue?vue&type=script&lang=js&"
import style0 from "./CourseInProfileList.vue?vue&type=style&index=0&id=f0b80520&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports